angular.module('impactx.cube').controller('StoredCubeCtrl', [
    '$scope',
    '$routeParams',
    'dataGen',
    'cubeMenu',
    'TranslationService',
    'ToastService',
    'BackService',
    'ToolbarService',
    StoredCubeCtrl
]);

function StoredCubeCtrl($scope, $routeParams, dataGen, cubeMenu, TranslationService, ToastService, BackService, ToolbarService) {
    var self = this;
    $scope.id = $routeParams.id;
    dataGen.getData($scope, {id: $routeParams.id}, "/monitor/cube/stored/get").then(function () {
        $scope.saveTranslation = TranslationService.get("save");
        $scope.deleteTranslation = TranslationService.get("delete");
        defineButtons();
    });

    self.save = function () {
        return dataGen.postAsForm({}, {cube: $scope.data}, "/monitor/cube/stored/save").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            cubeMenu.refreshCubes();
        });
    };

    self.delete = function () {
        return dataGen.postAsForm({}, {id: $scope.data.smdxId}, "/monitor/cube/stored/delete").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get("deleteSuccess"));
            cubeMenu.refreshCubes();
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.saveTranslation,
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.deleteTranslation,
                action: self.delete,
                type: 'dialogaction'
            },
            {
                label: $scope.trns.displayCube,
                linkFunction: getCubeLink,
                type: 'link'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function getCubeLink() {
        return "cube/" + $scope.id;
    }
}